import type { RouteRecordRaw } from "vue-router";

const commodityRoutes: RouteRecordRaw[] = [
  {
    path: "/balances/view",
    name: "view-commodity-balances",
    component: () => import("@/views/Commodity/ViewBalances.vue"),
    meta: {
      title: "Balances",
      requiresAuth: true,
      commodityPermission: "balances",
    },
  },
  {
    path: "/contracts/view",
    name: "view-commodity-contracts",
    component: () => import("@/views/Commodity/ViewContracts.vue"),
    meta: {
      title: "Contracts",
      requiresAuth: true,
      commodityPermission: "contracts",
    },
  },
  {
    path: "/unsigned-contracts/view",
    name: "view-unsigned-commodity-contracts",
    component: () =>
      import("@/views/Commodity/ViewContractsNeedingToBeSigned.vue"),
    meta: {
      title: "Contracts Needing to be Signed",
      requiresAuth: true,
      commodityPermission: "contracts",
    },
  },
  {
    path: "/activity/:type",
    name: "view-commodity-activity",
    component: () => import("@/views/Commodity/ViewActivity.vue"),
    meta: {
      title: "Activity",
      requiresAuth: true,
      commodityPermission: "activity",
    },
  },
  {
    path: "/bids/view",
    name: "view-commodity-bids",
    component: () => import("@/views/Commodity/ViewBids.vue"),
    meta: {
      title: "Cash Bids",
      requiresAuth: true,
      commodityPermission: "cashBids",
      guid: "159184FE-D4D7-42D2-1E1C-10228B3B2169",
    },
  },
  {
    path: "/offers/view",
    name: "view-commodity-offers",
    component: () => import("@/views/Commodity/ViewOffers.vue"),
    meta: {
      title: "Offers",
      requiresAuth: true,
      commodityPermission: "offers",
    },
  },
  {
    path: "/tickets/view",
    name: "view-commodity-tickets",
    component: () => import("@/views/Commodity/ViewTickets.vue"),
    meta: {
      title: "Tickets",
      requiresAuth: true,
      commodityPermission: "tickets",
    },
  },
  {
    path: "/grain-bank/view",
    name: "view-commodity-grain-bank",
    component: () => import("@/views/Commodity/ViewGrainBank.vue"),
    meta: {
      title: "Grain Bank",
      requiresAuth: true,
      commodityPermission: "grainBank",
    },
  },
  {
    path: "/proof-of-yield/view",
    name: "view-commodity-proof-of-yield",
    component: () => import("@/views/Commodity/ViewProofOfYield.vue"),
    meta: {
      title: "Proof of Yield",
      requiresAuth: true,
      commodityPermission: "proofOfYield",
    },
  },
];

export default commodityRoutes;
